import {combineReducers} from 'redux';
import _ from 'lodash';

import _AddInformationModel from './AddInformationModel';
import _AppListModel from './AppListModel';
import _AttrConfigModel from './AttrConfigModel';
import _ChannelListModel from './ChannelListModel';
import _CouponauditModel from './CouponauditModel';
import _CouponUnauditModel from './CouponUnauditModel';
import _LoginModel from './LoginModel';
import _PersonListModel from './PersonListModel';
import _GroupManageModel from './GroupManageModel';
import _HomeHeaderModel from './HomeHeaderModel';
import _OrderListModel from './OrderListModel';
import _OrderRefundListModel from './OrderRefundListModel';
import _MemberManageModel from './MemberManageModel';
import _StoreManagementModel from './StoreManagementModel';
import _PersonManageModel from './PersonManageModel';
import _SecurityKeyListModel from './SecurityKeyListModel';
import _ServiceTypeManageModel from './ServiceTypeMamageModel';
import _ServiceFollowUpModel from './ServiceFollowUpModel';
import _ServiceOrderModel from './ServiceOrderModel';
import _FeedBackListModel from './FeedBackListModel';
import _FeedBackFileListModel from './FeedBackFileListModel';
import _FeedBackDealListModel from './FeedBackDealListModel';
import _SettleAccountModel from './SettleAccountModel';
import _MempackageListModel from './MempackageListModel';
import _MempackageDetailModel from './MempackageDetailModel';
import _SPUListModel from './SPUListModel';
import _ProductClassModel from './ProductClassModel';
import _MemCouponListModel from './MemCouponListModel';
const allActions = {};
const allModels = {};
const allReducers = {};

const wrapModel = (model, alias) => {
    const selectors = {};
    const actions = {};
    const actionTypes = model.actionTypes;

    const modelWrapper = {
        wrappedModel: model,
        selectors,
        actions,
        actionTypes,
    };
    modelWrapper.api = model.api;
    modelWrapper.services = model.services;
    modelWrapper.selectors = model.selectors;
    Object.keys(model.actions).forEach(key => {
        actions[key] = function () {
            // actions暂时不进行额外处理
            // const ctx = { models:allModels, self:modelWrapper, actions };// FIXME
            return model.actions[key](...arguments);
        };
    });
    if (typeof model.reducers === 'function') {
        allReducers[model.name] = model.reducers;
    } else if (!_.isEmpty(model.reducers)) {
        allReducers[model.name] = combineReducers(model.reducers);
    }
    
    // 暂时主要目的是为了收集所有model的action、reducer
    Object.assign(allActions, actions);
    
    allModels[alias] = modelWrapper;

    return modelWrapper;
};

export const AddInformationModel = wrapModel(_AddInformationModel,'AddInformationModel');
export const AppListModel = wrapModel(_AppListModel,'AppListModel');
export const AttrConfigModel = wrapModel(_AttrConfigModel,'AttrConfigModel');
export const LoginModel = wrapModel(_LoginModel, 'LoginModel');
export const PersonListModel = wrapModel(_PersonListModel,'PersonListModel');
export const GroupManageModel = wrapModel(_GroupManageModel, 'GroupManageModel');
export const OrderListModel = wrapModel(_OrderListModel,'OrderListModel');
export const OrderRefundListModel = wrapModel(_OrderRefundListModel,'OrderRefundListModel');
export const CouponauditModel = wrapModel(_CouponauditModel,'CouponauditModel');
export const CouponUnAuditModel = wrapModel(_CouponUnauditModel,'CouponUnauditModel');
export const MemberManageModel = wrapModel(_MemberManageModel,'MemberManageModel');
export const StoreManagementModel = wrapModel(_StoreManagementModel,'StoreManagementModel');
export const PersonManageModel = wrapModel(_PersonManageModel,'PersonManageModel');
export const ChannelListModel = wrapModel(_ChannelListModel,'ChannelListModel');
export const HomeHeaderModel = wrapModel(_HomeHeaderModel,'HomeHeaderModel');
export const SecurityKeyListModel = wrapModel(_SecurityKeyListModel,'SecurityKeyListModel');
export const ServiceTypeManageModel = wrapModel(_ServiceTypeManageModel,'ServiceTypeManageModel');
export const ServiceFollowUpModel = wrapModel(_ServiceFollowUpModel,'ServiceFollowUpModel');
export const ServiceOrderModel = wrapModel(_ServiceOrderModel,'ServiceOrderModel');
export const FeedBackListModel = wrapModel(_FeedBackListModel,'FeedBackListModel');
export const FeedBackFileListModel = wrapModel(_FeedBackFileListModel,'FeedBackFileListModel');
export const FeedBackDealListModel = wrapModel(_FeedBackDealListModel,'FeedBackDealListModel');
export const SettleAccountModel = wrapModel(_SettleAccountModel,'SettleAccountModel');
export const MempackageListModel = wrapModel(_MempackageListModel,'MempackageListModel');
export const MempackageDetailModel = wrapModel(_MempackageDetailModel,'MempackageDetailModel');
export const SPUListModel = wrapModel(_SPUListModel,'SPUListModel');
export const ProductClassModel = wrapModel(_ProductClassModel,'ProductClassModel');
export const MemCouponListModel = wrapModel(_MemCouponListModel,'MemCouponListModel');

//--------------------------------------------------------------------------------
export const actions = allActions;
export const reducers = combineReducers(allReducers); 


// WEBPACK FOOTER //
// ./src/models/index.js